// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2u9AE","dragIcon":"Choice_dragIcon__2YoiQ","left":"Choice_left__13Dva","input":"Choice_input__1ufwn"};